//---------------------------------------------------
//  Nom du fichier : AdminPage.js 
//
//  Description: Fichier pour la page admin qui gère les report,
//               On n'y a seuleument accès si notre compte est admnistrateur (Alek et Vega)
//               Permet de supprimer le signalement ou le (commentaire/post/profil) signalé
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

import React, { useEffect, useState } from 'react';
import './AdminPage.css';
import './btn.css';
import { useNavigate } from 'react-router-dom';
import { callAPI } from './callAPI.js';
import Button from '@mui/material/Button';

function AdminPage({setPublication}) {

  const navigate = useNavigate();

  const [CommentsReports, setCommentsReports] = useState([])
  const [PublicationReports, setPublicationReports] = useState([])
  const [ProfilReports, setProfilReports] = useState([])

  const [openPub, setOpenPub] = useState(false)
  const [openCom, setOpenCom] = useState(false)
  const [openProf, setOpenProf] = useState(false)

  const render_reports = () => {
    const form = new FormData()
    form.append('type', 'getSignalement')

    callAPI("read", form)
    .then((data) => {
      setPublicationReports(data.result.posts)
      setCommentsReports(data.result.comments)
      setProfilReports(data.result.profiles)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }

  useEffect(() => {
    if(localStorage.getItem("role") != 1){
        navigate("/")
    }
    render_reports()
  },[])


  const DeleteObject = (type, id=null) => {


    const form = new FormData()
    form.append('type', type)
    let proper_name
    switch(type){
        case "delete_user" : proper_name = "user_id"; break;
        case "delete_comment":proper_name = "comment_id"; break;
        case "delete_post": proper_name = "post_id";break
    }
    form.append(proper_name, id)


    callAPI("write", form)
    .then((data) => {
      render_reports()
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }


  const DeleteReport = (type, id) => {


    const form = new FormData()
    form.append('type', "delete_report")
    form.append('report_type', type)
    form.append('report_id', id)
    callAPI("write", form)
    .then((data) => {
      render_reports()
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });
  }


  return (
    <>
      <div className='ReportContainer'>
        <h1>Reports</h1>

        <div className='ReportSection'>
          <h2 onClick={() => {setOpenPub(!openPub)}}>Publication Reports ({Object.keys(PublicationReports).length})</h2>
          { openPub && (Object.keys(PublicationReports).length > 0 ? Object.entries(PublicationReports).map(([postId, { reports }]) => (
            <div key={postId} className='Report'>

              <h3 className='reportId' onClick={() => { setPublication(postId); }}>Post ID: {postId}</h3>
              {reports.map((report, index) => (
                <div key={index} className='oneReport'>
                  <p>{report[0]}: {report[1]} report(s)</p>
                </div>
              ))}

              <div className='reportBtn'>
                  <Button variant="outlined" className='DeleteBtn btBase' id="cancelModify" onClick={() => {DeleteObject("delete_post", postId)}}>Delete Post</Button>
                  <Button variant="outlined" className='DeleteReport btBase' id="cancelModify" onClick={() => {DeleteReport("publication", postId)}}>Delete Report</Button>
              </div>
            </div>
          )) : 'No Reports')}

        </div>

        <div className='ReportSection'>
          <h2 onClick={() => {setOpenCom(!openCom)}}>Comments Reports ({Object.keys(CommentsReports).length})</h2>
          {openCom && (Object.keys(CommentsReports).length > 0 ? Object.entries(CommentsReports).map(([commentId, { reports, post_id, content }]) => (
            <div key={commentId} className='Report'>

              <h3 className='reportId' onClick={() => { setPublication(post_id); }}>Comment ID: {commentId}</h3>
              <p className='contenuComment'>Contenu : {content}</p>
              {reports.map((report, index) => (
                <div key={index} className='oneReport'>
                  <p>{report[0]}: {report[1]} report(s)</p>
                </div>
              ))}

              <div className='reportBtn'>
                  <Button variant="outlined" className='DeleteBtn btBase' id="cancelModify" onClick={() => {DeleteObject("delete_comment", commentId)}}>Delete Comment</Button>
                  <Button variant="outlined" className='DeleteReport btBase' id="cancelModify" onClick={() => {DeleteReport("comment", commentId)}}>Delete Report</Button>
              </div>
            </div>
          )) : 'No Reports')}
        </div>

        <div className='ReportSection'>
          <h2 onClick={() => {setOpenProf(!openProf)}}>Profile Reports ({Object.keys(ProfilReports).length})</h2>
          {openProf && (Object.keys(ProfilReports).length > 0 ? Object.entries(ProfilReports).map(([profileId, { reports }]) => (
            <div key={profileId} className='Report'>

              <h3 className='reportId'  onClick={() => { navigate("/profil/" + profileId + "/admin"); }}>Profile ID: {profileId}</h3>
              {reports.map((report, index) => (
                <div key={index} className='oneReport'>
                  <p>{report[0]}: {report[1]} report(s)</p>
                </div>
              ))}

              <div className='reportBtn'>
                  <Button variant="outlined" className='DeleteBtn btBase' id="cancelModify" onClick={() => {DeleteObject("delete_user", profileId)}}>Delete User</Button>
                  <Button variant="outlined" className='DeleteReport btBase' id="cancelModify" onClick={() => {DeleteReport("profil", profileId)}}>Delete Report</Button>
              </div>

            </div>
          )) : 'No Reports')}
        </div>
      </div>

      <span id="quit" className="material-symbols-outlined" onClick={() => { navigate("/") }} style={{ cursor: 'pointer' }}>close</span>
    </>
  );
}

export default AdminPage;